
import React, { useState } from 'react';
import Logo from '../../assets/Logo.svg';
import bgImage from "../../assets/back.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from 'react-router-dom';
import { getProfile, login, socialLogin } from '../../ApiController/ApiService';
import Swal from 'sweetalert2';
import { auth } from '../../firebaseconfig';
import { GoogleAuthProvider, FacebookAuthProvider, OAuthProvider, signInWithPopup } from 'firebase/auth';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
















    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        if (!email || !password) {
            setError('Please enter both email and password.');
            setLoading(false);
            return;
        }

        try {
            const result = await login({ email, password });
            console.log("Login Success:", result);
            Swal.fire({
                title: 'Login Successful',
                text: 'You have been logged in!',
                icon: 'success',
                confirmButtonText: 'Proceed',
            }).then(() => {
                navigate('/dashboard/home');
            });
        } catch (error) {
            setError(error.message || 'Login failed. Please check your credentials.');
            Swal.fire({
                title: 'Login Failed',
                text: error.message || 'Invalid email or password.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        } finally {
            setLoading(false);
        }
    };

    const handleSocialLogin = async (providerType) => {
    setLoading(true);
    setError(null);

    let provider;
    switch (providerType) {
        case 'Google':
            provider = new GoogleAuthProvider();
            break;
        case 'Facebook':
            provider = new FacebookAuthProvider();
            break;
        case 'Apple':
            provider = new OAuthProvider('apple.com');
            provider.addScope('email');
            provider.addScope('name');
            break;
        default:
            setError('Invalid provider selected.');
            setLoading(false);
            return;
    }

    try {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;

        // Extract user details
        const fullName = user.displayName || '';
        const [firstName = '', ...lastNameParts] = fullName.split(' ');
        const lastName = lastNameParts.join(' ') || '';
        const userEmail = user.email || '';

        if (!userEmail) {
            throw new Error('Email not provided by the provider.');
        }

        const idToken = await user.getIdToken();

        const socialData = {
            fullName: fullName || `User ${providerType}`,
            firstName: firstName || `User`,
            lastName: lastName || providerType,
            mobileNumber: 'N/A',
            email: userEmail,
            provider: providerType,
            idToken
        };

        // Send to backend
        const apiResult = await socialLogin(socialData);
        console.log(`${providerType} Login Success:`, apiResult);

        Swal.fire({
            title: `${providerType} Login Successful`,
            text: 'You have been logged in!',
            icon: 'success',
            confirmButtonText: 'Proceed',
        }).then(() => {
            navigate('/dashboard/home'); // ✅ updated redirect
        });
    } catch (error) {
        console.error(`${providerType} Login Error:`, error);
        setError(error.message || `${providerType} login failed. Please try again.`);
        Swal.fire({
            title: `${providerType} Login Failed`,
            text: error.message || 'Social login failed. Please try again.',
            icon: 'error',
            confirmButtonText: 'OK',
        });
    } finally {
        setLoading(false);
    }
};


    return (
        <div
            className="min-h-screen flex items-center justify-center bg-cover bg-bottom bg-cover relative"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className="flex flex-col items-center relative">
                <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />
                <div
                    className="relative bg-white rounded-2xl shadow-xl w-full sm:w-[490px] ps-8 pe-8 pb-8 pt-4 text-center"
                >
                    <button
                        onClick={() => navigate(-1)}
                        className="absolute top-4 left-4 text-[#2D0076] text-xl hover:text-[#6F1AFF] transition"
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>

                    <h2 className="text-2xl font-bold font-inter text-[#2D0076] font-[32px] text-gray-900">Welcome Back</h2>
                    <p className="text-sm font-nunito text-[#202224] font-600 mb-6">to Dispax Dispatcher Panel</p>

                    {error && (
                        <p className="text-red-500 text-sm mb-4">{error}</p>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="text-left mb-4">
                            <label className="block font-[18px] text-[#202224] mb-1">Email address:</label>
                            <input
                                type="email"
                                placeholder="johndoe@gmail.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-2 bg-[#F1F4F9] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                                required
                            />
                        </div>

                        <div className="text-left mb-4 relative">
                            <label className="block font-[18px] text-gray-700 mb-1">Password</label>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-4 py-2 bg-[#F1F4F9] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-9 text-gray-600"
                            >
                                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                            </button>

                            <Link to="/resetpassword" className="absolute right-0 font-[16px] hover:underline top-0 text-[#004EFF]">
                                Forget Password?
                            </Link>
                        </div>

                        <div className="flex items-center mb-4">
                            <input type="checkbox" id="remember" className="mr-2" />
                            <label htmlFor="remember" className="text-sm text-gray-600">Remember Password</label>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition disabled:opacity-50"
                        >
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                    </form>

                    <p className="text-[#00217A] font-[20px] mt-6">
                        Don’t have an account? <Link to="/signup" className="text-[#00217A] font-[20px] font-bold hover:underline">Sign up</Link>
                    </p>

                    <div className="mt-4 w-full">
                        <div className="-mx-8 flex items-center justify-center w-auto mb-4">
                            <div className="border-t border-gray-300 w-full"></div>
                            <span className="mx-4 text-sm text-gray-500 whitespace-nowrap">Or Login with</span>
                            <div className="border-t border-gray-300 w-full"></div>
                        </div>
                        <div className="flex justify-center gap-4">
                            {/* <button
                                onClick={() => handleSocialLogin('Facebook')}
                                disabled={loading}
                                className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow disabled:opacity-50"
                            >
                                <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/145/145802.png" alt="Facebook" />
                            </button> */}
                            <button
                                onClick={() => handleSocialLogin('Google')}
                                disabled={loading}
                                className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow disabled:opacity-50"
                            >
                                <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/281/281764.png" alt="Google" />
                            </button>
                            {/* <button
                                onClick={() => handleSocialLogin('Apple')}
                                disabled={loading}
                                className="flex items-center justify-center border p-2 rounded-md sm:w-[108px] hover:shadow disabled:opacity-50"
                            >
                                <img className="w-[20px]" src="https://cdn-icons-png.flaticon.com/512/0/747.png" alt="Apple" />
                            </button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;